// TODO if file still necessary move to utils folder otherwise delete it
/* eslint-disable no-extend-native */

/* Matrix transposition, e.g. [[1,2],[3,4],[5,6]].transpose() ==> [[1,3,5],[2,4,6]]
 * It holds that: xs.transpose().transpose() == xs
 * see: https://stackoverflow.com/a/46805290
 */
Object.defineProperty(Array.prototype, 'transpose', {
  value() {
    return (this.length === 0) ? this : this[0]
      .map((_col, c) => this.map((_row, r) => this[r][c]));
  },
});

/** Sliding window of arbitrary size, e.g. [1,2,3,4,5].window(3) == [[1,2,3],[2,3,4],[3,4,5]]
 * see: https://stackoverflow.com/questions/57001515/sliding-window-over-array-in-javascript
 */
Object.defineProperty(Array.prototype, 'window', {
  value(sz) {
    return this.map((_, i, ary) => ary.slice(i, i + sz)).slice(0, -sz + 1);
  },
});

// firefox 58 polyfill for https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flat
Object.defineProperty(Array.prototype, 'flatMap', {
  value(f) {
    return this.reduce((a, e) => a.concat(f(e)), []);
  },
});

// firefox 58 polyfill for https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flatMap
Object.defineProperty(Array.prototype, 'flat', {
  value() {
    return this.flatMap((e) => e);
  },
});

/** Partition an array in 2 based on a predicate,
 *  e.g. [1,2,3,4,5].partition(x=>x%2) == [[1,3,5],[2,4]] */
Object.defineProperty(Array.prototype, 'partition', {
  value(criterion) {
    return this.reduce((a, e) => { a[criterion(e) ? 0 : 1].push(e); return a; }, [[], []]);
  },
});

/** Build an array filled with incrasing integers, e.g. Array.range(1,5) == [1,2,3,4]
 * 2nd parameter is chosen to the likeness of Python's range function.
*/
// see: https://stackoverflow.com/a/44957114
Object.defineProperty(Array, 'range', {
  value(from, toExclusive) {
    return Array(toExclusive - from).fill(from).map((x, y) => x + y);
  },
});

/**
 *  Interpolation of 2 numerical vectors.
 *  @param {number[]} from_ary e.g. [255,255,255] (white)
 *  @param {number[]} to_ary e.g. [128,255,128] (light green)
 *  @param {number} scalar is normalized in range [0,1]
 *  @returns {number[]} e.g. [191.5,255,191.5] for scalar=0.5
 * */
Object.defineProperty(Array, 'affine_interpolate', {
  value(fromAry, toAry, scalar) {
    return [fromAry, toAry].transpose().map(([a0, a1]) => a0 + (a1 - a0) * scalar);
  },
});

/** Inverted function application. Please do not call it `ylppa` or `llac`.
 * @param {function<A,B>} f function to apply on the object it is passed to
 * @return {B} result type of function `f`
 * */
Object.defineProperty(Object.prototype, 'pass_this_into', {
  value(f) { return f(this); },
});

/** Function composition.
 * @param {function<B,C>} g function to compose with `this` (which must be a {function<A,B>}).
 * @return {function<A,C} composed function, i.e. (x) => g(this(x))
 */
Object.defineProperty(Object.prototype, 'andThen', {
  value(f) { return (...xs) => f(this(xs)); },
});

/** Lowercase the first letter of a string */
Object.defineProperty(String.prototype, 'toMinorCase', {
  value() {
    return this.length > 0 ? this[0].toLowerCase() + this.slice(1) : this;
  },
});
